import axios from "axios";
import { useState } from "react";
import { NotificationManager } from "react-notifications";
import Modal from "../../components/Modal/Modal";
import useAuth from "../../hooks/useAuth";
import { BASE_URL } from "../../utils/Element";
import AddLeadData from "./components/AddLeadData";

const initialData = {
  bds: "",
  broker: "",
  lead_source: "",
  contact: "",
  lead_type: "",
  link: "",
  contact_name: "",
  created_at: "",
  lead_status:"2",
  suggested_sale_price:"",
  suggested_cap_rate:"",
  portfolio:0,
  override_reason:""
};

const AddLeadModal = ({ showModal, onClose, from, onCallApi }) => {
  const [config] = useAuth();
  const [error, setError] = useState();
  const [disable, setDisable] = useState(false);
  const [formData, setFormData] = useState(initialData);

  const handleClose = () => {
    setFormData(initialData);
    onClose();
    setError();
    setDisable(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setDisable(true);
    const dataToSend = {
      bds: formData.bds,
      created_at : formData.created_at,
      broker: formData.broker,
      lead_source_id: formData.lead_source,
      contact_id: formData.contact,
      link_id: formData.link,
      override_reason:formData.override_reason,
      suggested_sale_price:formData.suggested_sale_price,
       suggested_cap_rate:formData?.suggested_cap_rate,
      lead_status: "2",
      lead_type: formData?.lead_type === "acquisition" ? 1 : 0,
      type: from === "Lead" ? 0 : from === "BOV" ? 1 : null,
      portfolio: formData?.portfolio ?? 0,
    
    };
    console.log(from , "from")
    axios
      .post(`${BASE_URL}/add-lead`, dataToSend, config)
      .then((res) => {
        NotificationManager.success(res?.data?.message);
        handleClose();
        onCallApi();
      })
      .catch((err) => {
        setDisable(false);
        setError(err.response.data.errors);
             if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
               NotificationManager.error(err.response?.data?.message);
             }
      });
  };

 

  return (
    <Modal title={`Add ${from}`} desc={`Add the ${from} information.`} show={showModal} onClose={handleClose}>
      <AddLeadData
        formData={formData}
        error={error}
        onSetFormData={(value) => {
          setFormData(value);
        }}
        onSetError={(value) => setError(value)}
        handleSubmit={handleSubmit}
        handleClose={handleClose}
        showModal={showModal}
        from={from}
        disable={disable}
      />
    </Modal>
  );
};

export default AddLeadModal;
